/* eslint-disable @typescript-eslint/naming-convention */
import Api, { HttpMethod } from './index';
import { DataMapper } from './transport';
import { IFromTransactionMapping } from './IDataMappings';
import { ICharityDonation } from './dataMapper/donationApiMapper';

export interface IDonationSkuResponse {
  SKU_BASE_ID: number;
  amount: string;
  product_id: string;
}

export interface IDonationSkuRequest {
  SKU_BASE_ID: number;
  QTY: number;
}

interface IDonationResponse {
  donation_desc: string;
  donation_logo: string;
  product_name: string;
  prod_base_id: number;
  donation_items: IDonationSkuResponse[];
}

export type ICharityDonationResponse = {
  donation_details: IDonationResponse[];
};

interface ICharityDonationApiConfig {
  api: Api;
  dataMapper: DataMapper;
}

export default class CharityDonationApi {
  api: Api;

  dataMapper: DataMapper;

  constructor({ api, dataMapper }: ICharityDonationApiConfig) {
    this.dataMapper = dataMapper;
    this.api = api;
  }

  async loadCharityDonations(): Promise<ICharityDonation[]> {
    const { basePath, brandRegionQuery } = this.api;

    const response = await this.api.makeRequest(HttpMethod.GET, {
      options: {
        credentials: 'include',
      },
      url: `${basePath}/list_donation_skus?${brandRegionQuery}`,
    });

    return this.dataMapper.mapResponse('donationApiMapper', response.data) as ICharityDonation[];
  }

  async removeDonations(skus: number[] ): Promise<IFromTransactionMapping> {
    const { baseTransactionPath, brandRegionQuery, transId } = this.api;
    const skusList = skus.join(',');

    const response = await this.api.makeRequest(HttpMethod.DELETE, {
      options: {
        credentials: 'include',
      },
      url: `${baseTransactionPath}/${transId}/cart_items/${skusList}?${brandRegionQuery}`,
    });

    return this.dataMapper.mapResponse('fromTransaction', response.data) as IFromTransactionMapping;
  }

  async addDonation(skuId: number): Promise<IFromTransactionMapping> {
    const { baseTransactionPath, brandRegionQuery, transId } = this.api;
    const body = this.dataMapper.mapRequest('donationApiMapper', { skuId });

    const response = await this.api.makeRequest(HttpMethod.POST, {
      body,
      options: {
        credentials: 'include',
      },
      url: `${baseTransactionPath}/${transId}/cart_items?${brandRegionQuery}`,
    });

    return this.dataMapper.mapResponse('fromTransaction', response.data) as IFromTransactionMapping;
  }
}
